import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
    PaginationProvider,
    SizePerPageDropdownStandalone,
    PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import { connect, useDispatch } from 'react-redux'
import { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter'
import { CSVLink } from 'react-csv'
import { Row, Card, CardText, CardBody, CardTitle, Col } from 'reactstrap'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { reportingSyncSelected, reportingSyncDateUpdated } from '../actions/reportsActions'
import ReactSelect from 'react-select'
import LicenseCell from './LicenseCell'
import DatePicker from 'react-datepicker'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'
import './navoverrides.css'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './datestyle.css'
import Moment from 'react-moment'

const { SearchBar } = Search
const { ExportCSVButton } = CSVExport

const defaultSorted = [
    {
        dataField: 'lastBackupDate',
        order: 'desc',
    },
]

const protectionFilterOptions = [
    { label: 'None', value: 'None' },
    { label: 'Mailbox', value: 'Mailbox' },
    { label: 'SharePoint', value: 'SharePoint' },
    { label: 'Complete', value: 'Complete' },
]

const backupFilterOptions = [
    { label: 'None', value: 'None' },
    { label: 'Archive', value: 'Archive-inactive' },
    { label: 'Archive (Active Only)', value: 'Archive' },
    { label: 'Mailbox', value: 'Mailbox-inactive' },
    { label: 'Mailbox (Active Only)', value: 'Mailbox' },
    { label: 'One-Drive', value: 'One-Drive-inactive' },
    { label: 'One-Drive (Active Only)', value: 'One-Drive' },
]

const licenseFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <LicenseCell cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
}

const IncludedUsersTable = ({ reportDetails, selectedCompany, syncsList, selectedSync, selectedSyncDate }) => {
    const dispatch = useDispatch()

    const columns = [
        {
            dataField: 'name',
            text: 'Mailbox',
            sort: true,
            editable: false,
            filter: textFilter({
                placeholder: 'Filter Mailbox...',
            }),
        },
        {
            dataField: 'email',
            text: 'Email',
            sort: true,
            editable: false,
            headerStyle: () => {
                return { width: '35%' }
            },
            filter: textFilter({
                placeholder: 'Filter Email...',
            }),
        },
        {
            dataField: 'ositLicenseType',
            text: 'License Status',
            sort: true,
            editable: false,
            csvFormatter: (cell, row, rowIndex) => `${cell}`,
            filter: selectFilter({
                placeholder: 'Filter License...',
                options: protectionFilterOptions,
            }),
        },
        {
            dataField: 'veeamLicensedState',
            text: 'Backup Details',
            formatter: licenseFormatter,
            editable: false,
            filter: selectFilter({
                placeholder: 'Filter Type...',
                options: backupFilterOptions,
                onFilter: (filterVal, data) => {
                    if (filterVal) {
                        if (filterVal === 'Archive') {
                            return data.filter(user => user.isArchiveBackedUpRecent == true);
                        }
                        else if (filterVal === 'Archive-inactive') {
                            return data.filter(user => user.isArchiveBackedUp == true);
                        }
                        else if (filterVal === 'Mailbox') {
                            return data.filter(user => user.isMailboxBackedUpRecent == true);
                        }
                        else if (filterVal === 'Mailbox-inactive') {
                            return data.filter(user => user.isMailboxBackedUp == true);
                        }
                        else if (filterVal === 'One-Drive') {
                            return data.filter(user => user.isOneDriveBackedUpRecent == true);
                        }
                        else if (filterVal === 'One-Drive-inactive') {
                            return data.filter(user => user.isOneDriveBackedUp == true);
                        }
                        else {
                            return data;
                        }
                    }

                    return data;
                }
            })
        },
        {
            dataField: 'isArchiveBackedUp',
            text: 'isArchiveBackedUp',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? "True" : "False"}`
        },
        {
            dataField: 'isMailboxBackedUp',
            text: 'isMailboxBackedUp',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? "True" : "False"}`
        },
        {
            dataField: 'isOneDriveBackedUp',
            text: 'isOneDriveBackedUp',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? "True" : "False"}`
        },
        {
            dataField: 'lastMailboxBackup',
            text: 'lastMailboxBackup',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? cell.toLocaleString("en-AU") : "-"}`
        },
        {
            dataField: 'lastOneDriveBackup',
            text: 'lastOneDriveBackup',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? cell.toLocaleString("en-AU") : "-"}`
        },
        {
            dataField: 'lastArchiveBackup',
            text: 'lastArchiveBackup',
            hidden: true,
            csvFormatter: (cell, row, rowIndex) => `${cell ? cell.toLocaleString("en-AU") : "-"}`
        }
    ]

    const handleHistoricalDate = (date) => {
        syncsList.every(sync => {
            let syncDate = new Date(sync.date)
            let dateSyncString = syncDate.toDateString()
            let dateString = date.toDateString()

            if (dateSyncString === dateString) {
                dispatch(reportingSyncSelected(sync, selectedCompany))
                dispatch(reportingSyncDateUpdated(date))
                return false;
            }

            return true;
        })
    }

    return (
        <div>
            <Row>
                <Col lg="8" md="8" sm="8" xs="12">
                    <Card style={{ marginBottom: '20px' }}>
                        <CardBody>
                            <CardTitle className="cardTitle">Billing Summary</CardTitle>
                            <CardText>
                                <Row style={{ marginTop: '5px' }}>
                                    <Col sm="4">
                                        <span className="cardContent">Total Licenses</span>
                                    </Col>
                                    <Col sm="4">
                                        <span className="cardContent">
                                            <b>{reportDetails.billedTotalCount}</b>
                                        </span>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '5px' }}>
                                    <Col sm="4">
                                        <span className="cardContent">Complete Licenses</span>
                                    </Col>
                                    <Col sm="4">
                                        <span className="cardContent">
                                            <b>{reportDetails.billedCompleteCount}</b>
                                        </span>
                                    </Col>
                                    <Col sm="4">
                                        <CSVLink
                                            color="primary"
                                            className="btn btn-primary btn-sm"
                                            filename={`${selectedCompany.label}-complete.csv`}
                                            data={reportDetails.salesExportComplete}
                                        >
                                            Export
                                        </CSVLink>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '5px' }}>
                                    <Col sm="4">
                                        <span className="cardContent">Mailbox Licenses</span>
                                    </Col>
                                    <Col sm="4">
                                        <span className="cardContent">
                                            <b>{reportDetails.billedMailboxCount}</b>
                                        </span>
                                    </Col>
                                    <Col sm="4">
                                        <CSVLink
                                            color="primary"
                                            className="btn btn-primary btn-sm"
                                            filename={`${selectedCompany.label}-mailbox.csv`}
                                            data={reportDetails.salesExportMailbox}>
                                            Export
                                        </CSVLink>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '5px' }}>
                                    <Col sm="4">
                                        <span className="cardContent">SharePoint Licenses</span>
                                    </Col>
                                    <Col sm="4">
                                        <span className="cardContent">
                                            <b>{reportDetails.billedSharePointCount}</b>
                                        </span>
                                    </Col>
                                    <Col sm="4">
                                        <CSVLink
                                            color="primary"
                                            className="btn btn-primary btn-sm"
                                            filename={`${selectedCompany.label}-sharepoint.csv`}
                                            data={reportDetails.salesExportSharePoint}
                                        >
                                            Export
                                        </CSVLink>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="4" md="4" sm="4" xs="6">
                    <div style={{ margin: '5px 10px' }}>
                        <div style={{ marginBottom: '10px' }}><b>View Historical Data</b></div>
                        <DatePicker
                            className="form-control"
                            style={{ paddingTop: '5px' }}
                            onChange={handleHistoricalDate}
                            placeholderText={'Click to see historical data'}
                            selected={selectedSyncDate}
                            includeDates={syncsList.map(s => new Date(s.date))}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div style={{ margin: '5px 10px' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <b>365 Tenants Found:</b> {reportDetails.tenancies}
                        </div>
                    </div>
                </Col>
            </Row>
            <PaginationProvider
                pagination={paginationFactory({
                    custom: true,
                    totalSize: reportDetails.veeamIncludedUsers.length,
                    sizePerPageList: [
                        { text: '10', value: 10 },
                        { text: '20', value: 20 },
                        { text: '50', value: 50 },
                        { text: '100', value: 100 },
                        { text: 'All', value: reportDetails.veeamIncludedUsers.length },
                    ],
                })}>
                {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                        bootstrap4
                        keyField="id"
                        data={reportDetails.veeamIncludedUsers}
                        columns={columns}
                        exportCSV={{
                            fileName: `${selectedCompany && selectedCompany.label}-veeam.csv`,
                            onlyExportFiltered: true,
                            exportAll: true,
                        }}
                        search
                    >
                        {(props) => {
                            return (
                                <div>
                                    <PaginationListStandalone style={{ marginLeft: '20px' }} {...paginationProps} />
                                    <ExportCSVButton className="btn-outline-primary" {...props.csvProps}>
                                        Export Data
                                    </ExportCSVButton>{' '}
                                    <SearchBar {...props.searchProps} />
                                    <SizePerPageDropdownStandalone
                                        btnContextual="btn-outline-primary"
                                        className="dropDownStyle"
                                        {...paginationProps}
                                    />
                                    <BootstrapTable
                                        keyField='email'
                                        defaultSorted={defaultSorted}
                                        bordered={false}
                                        {...props.baseProps}
                                        pagination={paginationFactory()}
                                        filter={filterFactory()}
                                        filterPosition="top"
                                        {...paginationTableProps}
                                    />
                                </div>
                            )
                        }}
                    </ToolkitProvider>
                )}
            </PaginationProvider>
        </div>
    )
}

const mapStateToProps = (state) => ({
    selectedSync: state.reports.selectedSync,
    selectedSyncDate: state.reports.selectedSyncDate,
    syncsList: state.reports.syncsList,
    selectedCompany: state.reports.selectedCompany,
})

const mapDispatchToProps = {
    reportingSyncSelected,
    reportingSyncDateUpdated
}

export default connect(mapStateToProps, mapDispatchToProps)(IncludedUsersTable)